import { t } from 'i18next';
import { equals, pick } from 'ramda';
import React from 'react';
import { useSelector } from 'react-redux';

import useDetectDiffInChanges from '../../../utils/hooks/useDetectDiffInChanges';
import { useForm } from '../../../utils/hooks/useForm';
import useWindowSize from '../../../utils/hooks/useWindowSize';
import { DisplayFlexS } from '../../../utils/stylesHelpers';
import { SCREEN_SIZES } from '../../constants/screenSizes';
import { TextArea } from '../common';

import FieldComment from './common/fieldComment';
import SaveBtn from './common/saveBtn';
import { InputWrapper, SaveButtonWrapper } from './companyEditS';

const DescriptionSetting = ({ isAdmin, updateCompany, setActiveSettingType }) => {
  const company = useSelector((state) => state.company.companyItem);
  const loading = useSelector((state) => state.company.loading);
  const { width: windowWidth } = useWindowSize();

  const handleSubmit = (values) => {
    updateCompany({ ...company, ...values }, isAdmin);
  };

  const hasChanges = (values) => {
    const companyDataToCompare = pick(Object.keys(values), company);
    return !equals(companyDataToCompare, values);
  };

  const { values, onChange, onBlur, onSubmit, dirty } = useForm({
    initialValues: {
      info: company.info || '',
    },
    onSubmit: handleSubmit,
  });

  useDetectDiffInChanges(() => hasChanges(values), onSubmit, setActiveSettingType);

  return (
    <form onSubmit={onSubmit}>
      <DisplayFlexS flexWrapScreenTablet="wrap" justifyScreenMedium="center">
        <DisplayFlexS justifyScreenMedium="center" direction="column" directionScreenMedium="column" minWidth="60%">
          <InputWrapper width="100%">
            <TextArea
              label={t('companyEdit.labels.desc')}
              name="info"
              type="text"
              value={values.info}
              rows={windowWidth > SCREEN_SIZES.MEDIUM ? '10' : '11'}
              onChange={onChange}
              onBlur={onBlur}
            />
          </InputWrapper>
        </DisplayFlexS>
        {windowWidth > SCREEN_SIZES.MEDIUM && (
          <FieldComment transPath="companyEdit.fieldComment.desc" marginTop="20px" />
        )}
      </DisplayFlexS>
      <SaveButtonWrapper marginTop="30" marginTopMobile="180">
        <SaveBtn loading={loading} disabled={!dirty && !hasChanges(values)} />
      </SaveButtonWrapper>
    </form>
  );
};

export default DescriptionSetting;
